import $ from 'jquery';
import Cleave from 'cleave.js';
import { PhoneInput } from 'modules/yii2/input/phone';

export default class PhoneConform {
    init() {
        var phone_confirm_form = $('#phoneConfirm');
        const phone_confirm_btn = '.js-phoneConfirm-btn';
        const phone_confirm_container = '.js-phoneConfirm-content';
        const phone_confirm_setting = '.js-phoneConfirm-info';

        if (phone_confirm_form.length > 0) {
            initPhoneConfirm();
        }

        function initPhoneConfirm() {
            var type = phone_confirm_form
                .find(phone_confirm_setting)
                .data('type');

            if (type === 'phone') {
                new PhoneInput().init(phone_confirm_form.find('.js-phone'));
            }
            const button = phone_confirm_form.find(phone_confirm_btn);
            button.off('click');
            button.on('click', submitPhoneConfirm);
        }

        function submitPhoneConfirm() {
            phone_confirm_form.addClass('g-loading');

            var url_form = phone_confirm_form
                .find(phone_confirm_setting)
                .data('url');
            var type = phone_confirm_form
                .find(phone_confirm_setting)
                .data('type');

            if (type === 'phone') {
                $.ajax({
                    url: url_form,
                    type: 'POST',
                    data: {
                        _csrf: $('meta[name="csrf-token"]').attr('content'),
                        phone: phone_confirm_form.find('.js-phone').val(),
                    },
                    cache: false,
                    success: (response) => {
                        phone_confirm_form.removeClass('g-loading');
                        const container = phone_confirm_form.find(
                            phone_confirm_container
                        );
                        container.html(response);
                        initPhoneConfirm();
                    },
                    error: (response) => {
                        alert('Ошибка сервера');
                    },
                });
            } else if (type === 'sms') {
                $.ajax({
                    url: url_form,
                    type: 'POST',
                    data: {
                        _csrf: $('meta[name="csrf-token"]').attr('content'),
                        sms: phone_confirm_form.find('.js-code').val(),
                    },
                    cache: false,
                    success: (response) => {
                        phone_confirm_form
                            .find(phone_confirm_container)
                            .html(response);
                        initPhoneConfirm();
                    },
                    error: (response) => {
                        alert('Ошибка сервера');
                    },
                });
            }
            return false;
        }
    }
}
